// extracted by mini-css-extract-plugin
export default {"examRules":"style_examRules__JzNLh","rule":"style_rule__6t3Dz","rule_title":"style_rule_title__Cd2gV","rule_description":"style_rule_description__XNToJ"};